import { fixFloat } from './fix-float.js';
import { toNumber } from './to-number.js';
export const centsToDollars = (cents) => {
    return fixFloat(toNumber(cents) * 0.01);
};
//# sourceMappingURL=cents-to-dollars.js.map